"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_HOME = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
exports.ADMIN_HOME = __1.ADMIN.child("", Home);
function Home() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "hero" },
            react_1.default.createElement("div", { className: "hero-body" },
                react_1.default.createElement("h1", { className: "title" }, "Home"))),
        react_1.default.createElement("section", { className: "main-section" },
            react_1.default.createElement("div", null, "ai and QA"))));
}
exports.default = Home;
